import civicshq from "../assets/civicshq.png";
import pasteproof from "../assets/pasteproof-128.png";
import freddie_mac_logo from "../assets/FreddieMacLogo.svg";
import jasaron from "../assets/jasaron_learning.png";
import ibm_logo from "../assets/IBM_logo.svg";

import civicshq_01 from "../assets/screenshots/civicshq/01-home.png";
import civicshq_02 from "../assets/screenshots/civicshq/02-bills.png";
import civicshq_03 from "../assets/screenshots/civicshq/03-politicians.png";
import civicshq_04 from "../assets/screenshots/civicshq/04-my-district.png";
import civicshq_05 from "../assets/screenshots/civicshq/05-match.png";

import fledge_01 from "../assets/screenshots/fledge/02-editor.png";
import fledge_02 from "../assets/screenshots/fledge/01-published-site.png";
import fledge_03 from "../assets/screenshots/fledge/03-manage.png";
import didi from "../assets/did-i.png";
import didi_01 from "../assets/screenshots/did-i/01-home.png";
import didi_02 from "../assets/screenshots/did-i/02-download.png";
import didi_03 from "../assets/screenshots/did-i/03-adhd.png";
import didi_04 from "../assets/screenshots/did-i/04-no-nagging.png";
import didi_05 from "../assets/screenshots/did-i/05-beta.png";
import civichall from "../assets/civichall.webp";
import civichall_01 from "../assets/screenshots/civichall/01-home.png";
import civichall_02 from "../assets/screenshots/civichall/02-how-do-i.png";
import civichall_03 from "../assets/screenshots/civichall/03-meetings.png";
import civichall_04 from "../assets/screenshots/civichall/04-search.png";
import civichall_05 from "../assets/screenshots/civichall/05-report-pothole.png";

import anithrift from "../assets/anithrift.png";
import anithrift_01 from "../assets/screenshots/anithrift/01-home.png";
import anithrift_02 from "../assets/screenshots/anithrift/02-sell.png";
import anithrift_03 from "../assets/screenshots/anithrift/03-signin.png";
import anithrift_04 from "../assets/screenshots/anithrift/04-about.png";
import anithrift_05 from "../assets/screenshots/anithrift/05-forum.png";

import pasteproof_01 from "../assets/screenshots/pasteproof/01-home.png";
import pasteproof_02 from "../assets/screenshots/pasteproof/02-pricing.png";
import pasteproof_03 from "../assets/screenshots/pasteproof/03-playground.png";
import pasteproof_04 from "../assets/screenshots/pasteproof/04-browser-extension.png";
import pasteproof_05 from "../assets/screenshots/pasteproof/05-api-slack.png";

import freddie_01 from "../assets/screenshots/freddie_mac/01-home.png";
import freddie_02 from "../assets/screenshots/freddie_mac/02-working-with-us.png";
import freddie_03 from "../assets/screenshots/freddie_mac/03-tools-learning.png";
import freddie_04 from "../assets/screenshots/freddie_mac/04-news-insights.png";
import freddie_05 from "../assets/screenshots/freddie_mac/05-mortgage-products.png";

import jasaron_03 from "../assets/screenshots/jasaron/03-services.png";
import jasaron_04 from "../assets/screenshots/jasaron/04-book-session.png";
import jasaron_05 from "../assets/screenshots/jasaron/05-contact.png";

import ibm_01 from "../assets/screenshots/ibm/01-ibmsearch.png";
import ibm_02 from "../assets/screenshots/ibm/02-search-results.png";
import ibm_03 from "../assets/screenshots/ibm/03-support-portal.png";
import ibm_04 from "../assets/screenshots/ibm/04-fix-central.png";
import ibm_05 from "../assets/screenshots/ibm/05-documentation.png";
export const tools = [
  {
    id: "react",
    name: "React",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    description: "Component-driven UIs with hooks, context, and performance tuning.",
  },
  {
    id: "typescript",
    name: "TypeScript",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    description: "Typed JavaScript for safer, more maintainable codebases.",
  },
  {
    id: "nextjs",
    name: "Next.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg",
    description: "SSR, routing, and full-stack React apps at scale.",
  },
  {
    id: "node",
    name: "Node.js",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    description: "APIs, tooling, and server-side logic in JavaScript.",
  },
  {
    id: "drupal",
    name: "Drupal",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/drupal/drupal-original.svg",
    description: "Enterprise CMS builds, migrations, and content pipelines.",
  },
  {
    id: "tailwind",
    name: "Tailwind",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
    description: "Utility-first styling for rapid, consistent interfaces.",
  },
  {
    id: "firebase",
    name: "Firebase",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
    description: "Auth, realtime data, and serverless backends.",
  },
  {
    id: "figma",
    name: "Figma",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
    description: "Design handoff, prototyping, and design systems.",
  },
  {
    id: "php",
    name: "PHP",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg",
    description: "Backend scripting for CMS and custom web apps.",
  },
  {
    id: "mysql",
    name: "MySQL",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    description: "Relational data modeling and query optimization.",
  },
  {
    id: "git",
    name: "Git",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    description: "Version control, branching strategies, and code review.",
  },
  {
    id: "wordpress",
    name: "WordPress",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-original.svg",
    description: "Custom themes, plugins, and content workflows.",
  },
  {
    id: "supabase",
    name: "Supabase",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/supabase/supabase-original.svg",
    description: "Postgres backend with auth, storage, and realtime APIs.",
  },
  {
    id: "stripe",
    name: "Stripe",
    icon: "https://cdn.simpleicons.org/stripe/635BFF",
    description: "Payments, subscriptions, and checkout flows.",
  },
  {
    id: "cloudflare",
    name: "Cloudflare",
    icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cloudflare/cloudflare-original.svg",
    description: "Edge hosting, DNS, and performance/security for web apps.",
  },
  {
    id: "vercel",
    name: "Vercel",
    icon: "https://cdn.simpleicons.org/vercel/FFFFFF",
    description: "Deploy, preview, and scale frontend apps at the edge.",
  },
  {
    id: "claude",
    name: "Claude",
    icon: "https://cdn.simpleicons.org/anthropic/D97757",
    description: "AI-assisted development, debugging, and workflow automation.",
  },
  {
    id: "cursor",
    name: "Cursor",
    icon: "https://cdn.simpleicons.org/cursor/6a9ae6",
    description: "AI-powered IDE for faster iteration and codebase navigation.",
  },
];

export const techStack = [
  "react",
  "typescript",
  "nextjs",
  "node",
  "tailwind",
  "firebase",
  "drupal",
  "figma",
].map((id) => {
  const tool = tools.find((t) => t.id === id);
  return { name: tool.name, icon: tool.icon };
});

export const data = [
  {
    id: 7,
    name: "Did I",
    slug: "did-i",
    shortCode: "DDID",
    category: "Mobile & PWA",
    image: didi,
    url: "https://did-i.app",
    live: true,
    color: "#2f7d6d",
    labelColor: "#5fc2ad",
    story: {
      role: "Designed and built it alone: the web app, the iPhone and Android apps, the Supabase backend, and the public site.",
      problem: "Habit apps only work if you open them. People forget to open them, so they never know if they locked the door or took the pills.",
      result: "Live at did-i.app. Free on iPhone, Android in beta, works offline as a PWA, and runs in eight languages.",
    },
    tags: ["React", "Expo", "Supabase", "PWA"],
    screenshots: [
      { src: didi_01, alt: "Homepage" },
      { src: didi_02, alt: "Download" },
      { src: didi_03, alt: "Habit tracker for ADHD" },
      { src: didi_04, alt: "Ask without nagging" },
      { src: didi_05, alt: "Android beta" },
    ],
    highlights: [
      "One question at a time on a widget, Apple Watch, or reminder",
      "Works offline as a PWA, with an Android app on the same UI",
      "Friends and families, sync through Supabase, eight languages",
    ],
    description:
      "Habit reminder app for people who forget to open habit trackers. Tap Did or Not yet. No account needed to start.",
  },
  {
    id: 6,
    name: "AniThrift",
    slug: "anithrift",
    shortCode: "ATHF",
    category: "E-Commerce",
    image: anithrift,
    url: "https://www.anithrift.com/",
    live: true,
    color: "#c44dff",
    labelColor: "#ff6bcb",
    story: {
      role: "Built the whole marketplace alone: storefront, seller tools, Stripe checkout and payouts, messaging, and the staging and production setup.",
      problem: "Collectors have no good place to sell pre-loved anime merch without high fees or rough listing tools.",
      result: "Live at anithrift.com. Free to list, sellers pay a fee only when an item sells, and payouts run through Stripe.",
    },
    tags: ["TypeScript", "Supabase", "Vercel", "Stripe"],
    screenshots: [
      { src: anithrift_01, alt: "Homepage" },
      { src: anithrift_02, alt: "Seller landing" },
      { src: anithrift_03, alt: "Sign in" },
      { src: anithrift_04, alt: "Browse listings" },
      { src: anithrift_05, alt: "Figures category" },
    ],
    highlights: [
      "Pre-loved anime merch marketplace with category browse and search",
      "Free-to-list seller flows with Stripe checkout and payouts",
      "Secure messaging, seller reviews, and built-in shipping tools",
    ],
    description:
      "Anime merch marketplace for collectors. Browse pre-loved figures, manga, and apparel; list for free with Stripe payouts, secure checkout, and in-app messaging.",
  },
  {
    id: 2,
    name: "Pasteproof",
    slug: "pasteproof",
    shortCode: "PSTP",
    category: "SaaS",
    image: pasteproof,
    url: "https://pasteproof.com",
    color: "#6a9ae6",
    labelColor: "#7fb6f4",
    story: {
      role: "Part of a small team. I built the website: the homepage, pricing, playground, and product pages. A teammate built the browser extension.",
      problem: "People paste personal data and secrets into web forms by accident, and nothing warns them first.",
      result: "Live at pasteproof.com. The extension runs detection in the browser, so pasted text is not sent anywhere.",
    },
    tags: ["React", "TypeScript", "Marketing Site"],
    screenshots: [
      { src: pasteproof_01, alt: "Homepage" },
      { src: pasteproof_02, alt: "Pricing" },
      { src: pasteproof_03, alt: "Interactive playground" },
      { src: pasteproof_04, alt: "Browser extension" },
      { src: pasteproof_05, alt: "APIs & Slack" },
    ],
    highlights: [
      "Built the pasteproof.com site: homepage, pricing, and product pages",
      "Interactive playground so visitors can try detection before installing",
      "Pages for the browser extension, APIs, and Slack integration",
    ],
    description:
      "Browser extension that warns you before you paste personal data or secrets into a web form. Detection runs in your browser.",
  },
  {
    id: 9,
    name: "CivicHall",
    slug: "civichall",
    shortCode: "CVHL",
    category: "Drupal",
    image: civichall,
    github: "https://github.com/Aaronlb912/civic_hall",
    live: false,
    color: "#1f3a5f",
    labelColor: "#6f9bd1",
    story: {
      role: "Built the site template, the content types, and the theme on Drupal CMS.",
      problem: "Small cities and one-person IT shops need a clean municipal site and rarely have a developer to build one.",
      result: "A public Drupal template with six content types, a Mercury subtheme, search, and forms. A clerk installs it and renames it.",
    },
    tags: ["Drupal", "PHP", "Twig"],
    screenshots: [
      { src: civichall_01, alt: "Home page with clerk counter and alerts" },
      { src: civichall_02, alt: "How do I listing" },
      { src: civichall_03, alt: "Meetings listing" },
      { src: civichall_04, alt: "Site search results" },
      { src: civichall_05, alt: "Report a pothole form" },
    ],
    highlights: [
      "Drupal CMS site template for city clerks and one-person IT shops",
      "Custom content types: How do I, Department, Official, Meeting, News, City alert",
      "Mercury subtheme, search, contact and records request forms",
      "civic_hall_meetings, a module on drupal.org that publishes meetings as a calendar feed",
    ],
    description:
      "Municipal site template on Drupal CMS with sample content for a fictional town, built so a clerk can install it and rename it.",
  },
  {
    id: 8,
    name: "Fledge",
    slug: "fledge",
    status: "Private repository",
    shortCode: "FLDG",
    category: "Developer Tools",
    live: false,
    color: "#3b6ea8",
    labelColor: "#7fb0e6",
    story: {
      role: "Built it alone: the block editor, draft and publish flow, access rules, and the export tool.",
      problem: "Developers who build client sites in Next.js get called for every text change after launch.",
      result: "Owners edit text, images, pages, and theme themselves. Only site members can open the editor, enforced in the database.",
    },
    tags: ["Next.js", "TypeScript", "Supabase"],
    screenshots: [
      { src: fledge_01, alt: "Visual editor" },
      { src: fledge_02, alt: "Published client site" },
      { src: fledge_03, alt: "Pages and settings" },
    ],
    highlights: [
      "Visual editor so clients change text, images, pages, and theme without a developer",
      "Draft and publish with version history, restore, and undo",
      "Row-level security so only site members can open the editor",
    ],
    description:
      "Hand off a client site built in Next.js. Owners edit blocks, pages, and theme in a visual editor, and developers keep the code.",
  },
  {
    id: 3,
    name: "Freddie Mac",
    slug: "freddie-mac",
    shortCode: "FDMC",
    category: "Enterprise",
    image: freddie_mac_logo,
    url: "https://sf.freddiemac.com",
    color: "#5c8a6e",
    labelColor: "#8bc4a0",
    story: {
      role: "Contract Web Platform Developer on the Drupal platform, June 2024 to September 2025.",
      problem: "A large public site was moving off a legacy platform and had to keep running through the change.",
      result: "The Drupal platform held 100% uptime. I rebuilt pages during the migration and reviewed pages before each go-live.",
    },
    tags: ["Drupal", "PHP", "CI/CD"],
    screenshots: [
      { src: freddie_01, alt: "Homepage" },
      { src: freddie_02, alt: "Working with Us" },
      { src: freddie_03, alt: "Technology & learning" },
      { src: freddie_04, alt: "News & insights" },
      { src: freddie_05, alt: "Mortgage products" },
    ],
    highlights: [
      "100% uptime on a mission-critical web ecosystem",
      "Rebuilt pages during the move off the legacy platform",
      "Worked on the end-to-end Drupal content deployment pipeline with CI/CD",
    ],
    description:
      "Mission-critical web ecosystem with 100% uptime, platform migration, and end-to-end Drupal content deployment.",
  },
  {
    id: 5,
    name: "IBM Search",
    slug: "ibm-search",
    shortCode: "IBMQ",
    category: "Enterprise",
    image: ibm_logo,
    url: "https://www.ibm.com/support/pages/ibmsearch",
    color: "#4a6670",
    labelColor: "#6a9ae6",
    story: {
      role: "Contract Drupal Developer, May 2022 to May 2023, working in PHP on the support search.",
      problem: "Support content in Drupal and the Enterprise Search index could drift apart, and users could not narrow their searches.",
      result: "Added a Component parameter to Drupal Search, a diagnostic script that checks published content against the index, repush scripts, and regression tests.",
    },
    tags: ["Drupal", "PHP", "Search"],
    screenshots: [
      { src: ibm_01, alt: "IBM Search" },
      { src: ibm_02, alt: "Search results" },
      { src: ibm_03, alt: "Support portal" },
      { src: ibm_04, alt: "Fix Central" },
      { src: ibm_05, alt: "Documentation" },
    ],
    highlights: [
      "Diagnostic scripts for Drupal content reconciliation",
      "Advanced search query capabilities in Drupal",
      "Nuanced content discovery for end users",
    ],
    description:
      "Diagnostic scripts for Drupal content reconciliation and advanced search query capabilities.",
  },
  {
    id: 1,
    name: "CivicsHQ",
    slug: "civicshq",
    shortCode: "CVHQ",
    category: "Civic Tech",
    image: civicshq,
    url: "https://civicshq.com",
    live: true,
    color: "#1a5c45",
    labelColor: "#2d8a66",
    tags: ["Next.js", "TypeScript", "Civic Data"],
    screenshots: [
      { src: civicshq_01, alt: "Civic dashboard" },
      { src: civicshq_02, alt: "Legislation feed" },
      { src: civicshq_03, alt: "Politician lookup" },
      { src: civicshq_04, alt: "District lookup" },
      { src: civicshq_05, alt: "Match score" },
    ],
    highlights: [
      "Federal and state legislative tracker with AI summaries",
      "Politician profiles and district lookup by address or ZIP",
      "Match score tool to compare your views with representatives",
    ],
    description:
      "Public utility platform for civic engagement. Track 8,000+ active bills, browse politician profiles, look up your district, and explore legislative match scores. No account required.",
  },
  {
    id: 4,
    name: "Jasaron",
    slug: "jasaron",
    status: "Client site, no longer live",
    shortCode: "JSRN",
    category: "Education",
    image: jasaron,
    live: false,
    color: "#e8a838",
    labelColor: "#ffd166",
    story: {
      role: "Senior Web Coordinator on a contract, May 2020 to June 2024.",
      problem: "A small education business needed its website kept current and easier to use.",
      result: "Kept the site updated for four years and made usability changes based on market research. The site is no longer live.",
    },
    tags: ["HTML5", "CSS3", "UX"],
    screenshots: [
      { src: jasaron, alt: "Homepage" },
      { src: jasaron_03, alt: "Services" },
      { src: jasaron_04, alt: "Book a session" },
      { src: jasaron_05, alt: "Contact us" },
    ],
    highlights: [
      "Responsive educational interfaces aligned to client goals",
      "Full client website maintenance and optimization",
      "UX-driven usability improvements from market research",
    ],
    description:
      "Responsive educational interfaces, client site maintenance, and UX-driven usability improvements.",
  },
];

export const CONTACT_EMAIL = "abryantdev@gmail.com";

export const contactMailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  "Portfolio inquiry"
)}&body=${encodeURIComponent("Hi Aaron,\n\n")}`;
